export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="w-full px-4 md:px-6 py-16 md:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold font-label tracking-wide mb-5">
              高清不缓冲 · 免费无广告
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 font-heading leading-tight">
              木瓜影视
              <br />
              <span className="text-primary-600">高清不缓冲在线观看平台</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-500 font-medium font-heading">
              极速播放 · 畅享流畅观影
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              木瓜影视专注为影视爱好者提供极致观影体验。平台汇聚最新电视剧和电影高清资源，涵盖悬疑烧脑、温情治愈、科幻巨制、韩流热播等多元题材。每日持续更新，无需注册付费，打开即看——高清不缓冲在线观看，从木瓜影视开始。
            </p>

            <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-label">5000万+</div>
                <div className="text-xs text-foreground-500 mt-1">累计用户</div>
              </div>
              <div className="w-px h-8 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-label">3万+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-label">24h</div>
                <div className="text-xs text-foreground-500 mt-1">极速更新</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScroll('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); handleScroll('#features'); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-background-300 text-foreground-700 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-100/50 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20golden%20and%20amber%20tones%2C%20film%20reel%20elements%2C%20soft%20dramatic%20lighting%2C%20movie%20theater%20atmosphere%2C%20elegant%20artistic%20style%2C%20luxurious%20texture%2C%20no%20text&width=700&height=500&seq=hero-visual&orientation=landscape"
                alt="木瓜影视 - 高清不缓冲在线观看平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="700"
                height="500"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}